export default __webpack_public_path__ + "static/media/youtube-dark.e1538a0b.svg";